<template>
    <div>
        <div v-if="view.layout && view.layout.rows">
            <div v-for="(row, index) in view.layout.rows">
                <row-renderer :layout="view.layout" :key="index + view.id + 'row'"
                              :row="row" :index="index" :table="table" :view="view"></row-renderer>
            </div>

        </div>

        <div v-else>
            Layout not complete.
        </div>
    </div>
</template>

<script>

    export default {
        name: 'CustomLayoutRenderer',
        props: ['view', 'table'],
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        }
    }
</script>

<style>

</style>
